import { Navigate, Route, Routes } from "react-router-dom";
import { DataProvider, useData } from "./data/DataContext";
import { Sidebar } from "./components/Sidebar";
import { TopBar } from "./components/TopBar";
import { DiagPage } from "./pages/DiagPage";
import { MyObjectivesPage } from "./pages/MyObjectivesPage";
import { TeamDashboardPage } from "./pages/TeamDashboardPage";
import { ObjectivesPage } from "./pages/ObjectivesPage";
import { CategoriesPage } from "./pages/CategoriesPage";
import { CategoryPage } from "./pages/CategoryPage";
import { CoverPage } from "./pages/CoverPage";
import { PersonDetailPage } from "./pages/PersonDetailPage";
import { ReportsPage } from "./pages/ReportsPage";
import { AdminPage } from "./pages/AdminPage";

/**
 * App shell - lives inside DataProvider so it can read role from context
 * and gate routes accordingly. Mirrors the role gates from the live app:
 *   isStaff  = Admin | Exec | CLT
 *   canCover = isStaff OR (User && me.covers.length > 0)
 */
function AppShell() {
  const { me } = useData();
  const isStaff = me.role === "Admin" || me.role === "Exec" || me.role === "CLT";
  const canCover = isStaff || (me.role === "User" && me.covers.length > 0);

  return (
    <div className="grid min-h-screen grid-cols-[248px_1fr] bg-paper text-ink print:block print:min-h-0 print:bg-white">
      <Sidebar />
      <div className="flex min-w-0 flex-col">
        <TopBar />
        <main className="flex-1 overflow-y-auto px-9 pt-7 pb-12 print:p-0 print:overflow-visible">
          <Routes>
            <Route path="/" element={<MyObjectivesPage />} />
            {isStaff && <Route path="/team" element={<TeamDashboardPage />} />}
            {isStaff && <Route path="/objectives" element={<ObjectivesPage />} />}
            {isStaff && <Route path="/categories" element={<CategoriesPage />} />}
            {isStaff && <Route path="/category/:name" element={<CategoryPage />} />}
            {canCover && <Route path="/cover" element={<CoverPage />} />}
            {canCover && <Route path="/person/:id" element={<PersonDetailPage />} />}
            {isStaff && <Route path="/reports" element={<ReportsPage />} />}
            {isStaff && <Route path="/admin" element={<AdminPage />} />}
            <Route path="/diag" element={<DiagPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <DataProvider>
      <AppShell />
    </DataProvider>
  );
}
